<template>
  <div>
    <el-card>
      <div class="header-wrapper">
        <div class="left">
          <img class="logo" src="@/assets/gzh/pc/logo.png" alt="" />
          <span class="title">雷士服务商城管理</span>
        </div>
        <div class="right">
          <!-- <img class="rightImg" src="@/assets/gzh/测试图片.webp" alt="" />
          <div class="line"></div> -->
          <div class="avatar-wrapper">
            <img class="avatar" :src="userInfo.avatar" alt="" />
          </div>
          <div class="userName">{{ userInfo.name }}</div>
          <!-- <el-dropdown trigger="click" size="small">
            <span class="el-dropdown-link"> 管理员名称<i class="el-icon-arrow-down el-icon--right"></i> </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
// import apis from "@/apis/gzh.js";
import api from "@/apis";
export default {
  name: "headerLogo",
  data() {
    return {
      userInfo: {}
    };
  },
  mounted() {
    this.getUserinfo();
  },
  methods: {
    getUserinfo() {
      api.getUserinfo().then(res => {
        this.userInfo = res.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-card {
  border-radius: 0;
  .el-card__body {
    padding: 0;
    height: 112px;
    display: flex;
    align-items: center;
  }
  .header-wrapper {
    flex: 1;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .logo {
        width: 223px;
        height: 44px;
        margin-right: 15px;
      }
      .title {
        font-size: 33px;
        font-weight: 600;
        margin-top: 5px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      margin-right: 50px;
      .rightImg {
        width: 30px;
        height: 30px;
      }
      .userName {
        font-size: 26px;
      }
      // .line {
      //   width: 1px;
      //   height: 30px;
      //   background-color: #e3e6f5;
      //   margin: 0 30px;
      // }
      .avatar-wrapper {
        width: 68px;
        height: 68px;
        line-height: 68px;
        .avatar {
          width: 68px;
          height: 68px;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
      // .el-dropdown-link {
      //   font-size: 26px;
      // }
    }
  }
}
</style>
